export const OperationEnum = {
    StartWith: 0,
    Contains: 1,
    EndWith: 2,
    Equals: 3,
    Greater: 4,
    GreaterOrEquals: 5,
    Less: 6,
    LessOrEquals: 7,
    Different: 8,
};

type constOperationType = typeof OperationEnum;

export type OperationEnum = constOperationType[keyof constOperationType];
